import { isRSAA, RSAA } from 'redux-api-middleware';

import { getToken, getSettings } from './selectors';

const endpointWithSelectedAccount = '/me/';

export const authMiddleware = store => next => action => {
  if (isRSAA(action)) {
    const token = getToken(store.getState());
    const settings = getSettings(store.getState());

    if (token.isValid()) {
      const { accessToken } = token;
      // eslint-disable-next-line
      action[RSAA].headers.Authorization = `Bearer ${accessToken}`;
    }

    if (
      action[RSAA].endpoint.endsWith(endpointWithSelectedAccount) &&
      settings.selectedAccountId
    ) {
      // eslint-disable-next-line
      action[
        RSAA
      ].endpoint += `?selected_account_id=${settings.selectedAccountId}`;
    }

    return next(action);
  }

  return next(action);
};
